import React, {Fragment, useMemo} from 'react';
import {Button, Card, Col, Form, Input, Modal, Row, Steps,Alert} from 'antd';
import {
  GUTTER_SM,
  MARGIN_MD,
  MARGIN_SM,
  MODAL_WIDTH_SM,
  MODAL_WIDTH_XL,
  PADDING_MD,
  SPAN_FULL,
  SPAN_ONE_QUARTER,
  SPAN_ONE_THIRD,
  SPAN_THREE_QUARTERS,
  SPAN_TWO_THIRDS
} from '../../../../styles/constants';
import {
  changeFileMappingWizardForm,
  createFileMappingWizardFileMapping,
  getFileMappingWizardCsvHeader,
  hideFileMappingWizard,
  hideFileMappingWizardComponents,
  hideFileMappingWizardCubeComponents,
  readFileMappingWizardCube,
  selectFileMappingWizardColumn,
  setFileMappingWizardStep,
  showFileMappingWizardComponents,
  showFileMappingWizardCubeComponents,
  checkMandatoryFields,
  checkCircularDependencies,
  getFileMappingWizardCalculatedField,
  onDeleteCalcField,
  editCalcField,
  hideDependencyError,
  createTempTable,
  deleteTempTable,
  showModalTempTable,
  hideModalTempTable
} from './actions';
import FileMappingWizardCsvUploadForm from './csv-form';
import FileMappingWizardComponentList from './component-list';
import FileMappingWizardCubeSelector from './cube-selector';
import FileMappingWizardCsvRowList from './csv-row-list';
import FileMappingWizardCsvColumnValueList from './csv-column-value-list';
import FileMappingWizardCalcColumnValueList  from './calculated-field-value-list';
import FileMappingWizardComponentMapper from './component-mapper';
import FileMappingWizardCubeComponentList from './cube-component-list';
import Call from '../../../../hocs/call';
import {showFileMappingWizardCsvRowList} from './csv-row-list/actions';
import {showFileMappingWizardColumnValueList} from './csv-column-value-list/actions';
import { showFileMappingWizardCalculatedColumnValueList } from './calculated-field-value-list/actions';
import './style.css';
import CubeComponentList from '../../../../components/cube-component-list';
import {translate} from 'react-i18next';
import {
  DOT_STAT_COLUMN_NAME,
  FILE_MAPPING_WIZARD_STEP_COMPONENT_MAPPING,
  FILE_MAPPING_WIZARD_STEP_CSV_UPLOAD,
  FILE_MAPPING_WIZARD_STEP_CUBE_SELECTION,
  FILE_MAPPING_WIZARD_STEP_NAME
} from './reducer';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {getLocalizedStr} from '../../../../middlewares/i18n/utils';
import FileMappingComponentList from '../../../../components/file-mapping-component-list';
import EnhancedModal from '../../../../components/enhanced-modal';
import {DataLanguageConsumer} from "../../../../contexts/DataLanguage";
import ZoomableTextArea from "../../../../components/zoomable-textarea";
import _ from "lodash";
import {ID_MAX_LEN} from "../../../../constants/generals";
import {isIDValidWithHelp} from "../../../../utils/artefactValidators";
import { useEffect } from 'react';
import { hideComponentValueDefinitionForm, readComponentCodelistCodesItemsPage, saveComponentValueDefinition, setComponentValueDefinitionType, setComponentValueDefinitionValue, showComponentValueDefinitionForm } from './component-list/actions';
import PerfInput from "../../../../components/perf-input";
import FileMappingWizardAddField from './add-field/index';
import FileMappingWizardRulesImportForm from './import-csv-form/index';
import FileMappingWizardRulesExportForm from './export-rules-form/index';
import FileMappingWizardHeadersSortColumn from './select-sort/index';
import FileMappingWizardCsvHeaderFormModal from './csv-header-edit/index'
import { showFileMappingWizardAddFieldModal } from './add-field/actions';
import { showFileMappingWizardCalcRowList } from './csv-row-list/actions';
import { showImportCalcRules } from './import-csv-form/actions';
import { showExportCalcRules } from './export-rules-form/actions';
import { showSelectSort } from './select-sort/actions';
import { showFileMappingWizardCsvHeaderFormModal } from './csv-header-edit/actions';

const mapStateToProps = ({
                           app,
                           config,
                           scenes: {dataManager: {fileMapping: {components: {wizard}}}}
                         }) => ({
  appLanguage: app.language,
  dataLanguages: config.dataManagement.dataLanguages,
  isVisible: wizard.local.isVisible,
  isCubeComponentsVisible: wizard.local.isCubeComponentsVisible,
  isComponentsVisible: wizard.local.isComponentsVisible,
  csvForm: wizard.shared.csvForm,
  csvServerPath: wizard.shared.csvServerPath,
  xmlServerPath: wizard.shared.xmlServerPath,
  csvHeader: wizard.shared.csvHeader,
  cubeId: wizard.shared.cubeId,
  cube: wizard.shared.cube,
  selectedColumnName: wizard.shared.selectedColumnName,
  components: wizard.shared.components,
  name: wizard.local.name,
  description: wizard.local.description,
  tid: wizard.local.tid,
  step: wizard.local.step,
  mandatoryFieldsChecked:wizard.shared.mandatoryFieldsChecked,
  componentValueDefinitionFormVisible: wizard.shared.componentValueDefinitionFormVisible,
  componentValueDefinition: wizard.shared.componentValueDefinition,
  componentCodelistCodesItemsPage: wizard.shared.componentCodelistCodesItemsPage,
  componentCodelistCodesItemsCount: wizard.shared.componentCodelistCodesItemsCount,
  mappingHasCircularDependencies: wizard.shared.mappingHasCircularDependencies,
  fileFormat: wizard.shared.fileFormat,
  configuredPlugins: wizard.shared.configuredPlugins,
  permissions: app.user.permissions,
  secondServerPath: wizard.shared.secondServerPath,
  thirdServerPath: wizard.shared.thirdServerPath,
  addedHeaders: wizard.shared.addedHeaders,
  mergedHeader: wizard.shared.mergedHeader,
  fetchNewField: wizard.components.addField.fetchNewField,
  tempTableName: wizard.shared.tempTableName,
  deleteTempTableName: wizard.shared.deleteTempTableName,
  isDependencyErrorVisible: wizard.components.addField.isDependencyErrorVisible,
  checkDeleteTempTable: wizard.shared.deleteTempTable,
  showModal: wizard.shared.showModalTemptable
});

const mapDispatchToProps = dispatch => ({
  onHide: () => dispatch(hideFileMappingWizard()),
  onCsvRowListShow: () => dispatch(showFileMappingWizardCsvRowList()),
  onCsvColumnValueListShow: columnName => dispatch(showFileMappingWizardColumnValueList(columnName)),
  onCalcColumnValueListShow: (columnName, hasAlias) => dispatch(showFileMappingWizardCalculatedColumnValueList(columnName, hasAlias)),
  onColumnSelect: (columnName, originalColumnName, tempTableName) => dispatch(selectFileMappingWizardColumn(columnName, originalColumnName, tempTableName)),
  onCreateFileMapping: (name, description, tid, cubeId, components, csvForm, xmlServerPath, processFilePath, pluginUid, icon, iconColor, sequenceMapping, mergedHeader) =>
    dispatch(createFileMappingWizardFileMapping(name, description, tid, cubeId, components, csvForm, xmlServerPath, processFilePath, pluginUid, icon, iconColor, sequenceMapping, mergedHeader)),
  onStepSet: step => dispatch(setFileMappingWizardStep(step)),
  onFormChange: fields => dispatch(changeFileMappingWizardForm(fields)),
  fetchCsvHeader: ({
                     csvServerPath,
                     csvSeparator,
                     csvDelimiter,
                     csvHasHeader,
                     csvHasDotStatFormat,
                     fileFormat
                   }) =>
    dispatch(getFileMappingWizardCsvHeader(csvSeparator, csvDelimiter, csvHasHeader, csvServerPath, csvHasDotStatFormat, fileFormat === 'plugin' ? 2 : 0)),
  fetchCalcField : ({tempTableName}) => dispatch(getFileMappingWizardCalculatedField(tempTableName)),
  fetchCube: cubeId => dispatch(readFileMappingWizardCube(cubeId)),
  onDeleteTempTable : tempTableName => dispatch(deleteTempTable(tempTableName)),
  onCubeComponentsShow: () => dispatch(showFileMappingWizardCubeComponents()),
  onCubeComponentsHide: () => dispatch(hideFileMappingWizardCubeComponents()),
  onComponentsShow: () => dispatch(showFileMappingWizardComponents()),
  onComponentsHide: () => dispatch(hideFileMappingWizardComponents()),
  mandatoryFieldsCheck: () => dispatch(checkMandatoryFields()),
  onCircularDependenciesCheck: () => dispatch(checkCircularDependencies()),
  onComponentValueDefinitionFormShow: (component) => dispatch(showComponentValueDefinitionForm(component)),
  onComponentValueDefinitionFormHide: () => dispatch(hideComponentValueDefinitionForm()),
  onComponentValueDefinitionTypeSet: (type, cubeComponents) => dispatch(setComponentValueDefinitionType(type, cubeComponents)),
  onComponentValueDefinitionValueSet: (value) => dispatch(setComponentValueDefinitionValue(value)),
  onComponentValueDefinitionSave: () => dispatch(saveComponentValueDefinition()),
  onAddFieldModalShow: () => dispatch(showFileMappingWizardAddFieldModal()),
  onPreview: () => dispatch(showFileMappingWizardCalcRowList()),
  onDeleteCalcField: (tableName, aliasQuery) => dispatch(onDeleteCalcField(tableName, aliasQuery)),
  onEditCalcField: (tableName, aliasQuery) => dispatch(editCalcField(tableName, aliasQuery)),
  onEditCsvField: (aliasQuery) => dispatch(showFileMappingWizardCsvHeaderFormModal(aliasQuery)),
  fetchCodelistCodesItemsPage: ({
    codelistTriplet,
    language,
    pageNum,
    pageSize,
    searchText,
    filters,
    sortCol,
    sortByDesc,
    componentName
  }) => dispatch(readComponentCodelistCodesItemsPage({
      codelistTriplet,
      language,
      pageNum,
      pageSize,
      searchText,
      filters,
      sortCol,
      sortByDesc,
      componentName
    })),
    onDownloadShow: () => dispatch(showExportCalcRules()),
    onShowImportCalcRules: () => dispatch(showImportCalcRules()),
    onDependencyErrorHide: () => dispatch(hideDependencyError()),
    onSelectSortShow: () => dispatch(showSelectSort()),
    onEnableCalcFields: (fileServerPath, separator, delimiter, fileFormat) => {
      dispatch(createTempTable(fileServerPath, separator, delimiter, fileFormat === 'plugin' ? 2 : 0))
      dispatch(hideModalTempTable())
    },
    onModalTempTableShow: () => dispatch(showModalTempTable()),
    onModalTempTableHide: () => dispatch(hideModalTempTable())
});

const mapPropsToFields = ({name, description, tid}) => ({
  name: Form.createFormField({value: name}),
  description: Form.createFormField({value: description}),
  tid: Form.createFormField({value: tid}),
});

// TODO: prevent multiple changes relative to same value
const onFieldsChange = (props, fields) => {

  const newFields = _.mapValues(fields, ({value}) => value);
  if (newFields.name && newFields.name.length > ID_MAX_LEN) {
    Modal.warning({
      title: props.t('commons.alerts.fieldTooLong.title'),
      content: props.t('commons.alerts.fieldTooLong.content', {maxLen: ID_MAX_LEN})
    });
    props.onFormChange({name: props.name, description: props.description, tid: props.tid});
  } else {
    props.onFormChange(newFields);
  }
};

const cardStyle = {
  type: 'inner',
  headStyle: {
    paddingLeft: PADDING_MD,
    paddingRight: PADDING_MD
  },
  bodyStyle: {
    paddingLeft: PADDING_MD,
    paddingRight: PADDING_MD,
    height: 420,
  }
};

const formItemLayout = {
  labelCol: {span: SPAN_ONE_THIRD},
  wrapperCol: {span: SPAN_TWO_THIRDS},
};

const stepNameFormItemLayout = {
  labelCol: {span: SPAN_ONE_QUARTER},
  wrapperCol: {span: SPAN_THREE_QUARTERS},
};

const FileMappingWizard = ({
                             t,
                             appLanguage,
                             dataLanguages,
                             form,
                             isVisible,
                             step,
                             csvForm,
                             csvServerPath,
                             xmlServerPath,
                             isCubeComponentsVisible,
                             isComponentsVisible,
                             csvHeader,
                             cubeId,
                             cube,
                             name,
                             description,
                             tid,
                             selectedColumnName,
                             components,
                             onHide,
                             onCsvRowListShow,
                             onAddFieldModalShow,
                             onCsvColumnValueListShow,
                             onCalcColumnValueListShow,
                             onColumnSelect,
                             onCreateFileMapping,
                             onStepSet,
                             onCubeComponentsShow,
                             onCubeComponentsHide,
                             onComponentsShow,
                             onComponentsHide,
                             fetchCsvHeader,
                             fetchCube,
                             mandatoryFieldsChecked,
                             mandatoryFieldsCheck,
                             mappingHasCircularDependencies,
                             onCircularDependenciesCheck,
                             componentValueDefinitionFormVisible,
                             onComponentValueDefinitionFormShow,
                             onComponentValueDefinitionFormHide,
                             onComponentValueDefinitionSave,
                             onComponentValueDefinitionTypeSet,
                             componentValueDefinition,
                             onComponentValueDefinitionValueSet,
                             componentCodelistCodesItemsPage,
                             componentCodelistCodesItemsCount,
                             fetchCodelistCodesItemsPage,
                             fileFormat,
                             configuredPlugins,
                             permissions,
                             secondServerPath,
                             thirdServerPath,
                             addedHeaders,
                             tempTableName,
                             fetchCalcField,
                             fetchNewField,
                             onPreview,
                             onDeleteCalcField,
                             onEditCalcField,
                             onEditCsvField,
                             onDownloadShow,
                             onSelectSortShow,
                             onShowImportCalcRules,
                             onDependencyErrorHide,
                             isDependencyErrorVisible,
                             mergedHeader,
                             onEnableCalcFields,
                             onDeleteTempTable,
                             checkDeleteTempTable,
                             deleteTempTableName,
                             onModalTempTableShow,
                             onModalTempTableHide,
                             showModal
                            }) => {  
const hasPermissionForPlugins = useMemo(() => permissions.functionality.includes("plugins"), [permissions])                            
const selectedPlugin = useMemo(() => {
    if (hasPermissionForPlugins && csvForm.configuredPlugin) {
        return configuredPlugins.find(plugin => plugin.PluginUid === csvForm.configuredPlugin)
    }
    return null
}, [csvForm.configuredPlugin]);     
const processFileServerPath = useMemo(() => {
  if (!secondServerPath || !selectedPlugin || !selectedPlugin.ProcessFileEnabled) {
      return null;
  }
  if (secondServerPath && !selectedPlugin.TransformFileEnabled) {
      return secondServerPath;
  }
  return thirdServerPath;
}, [secondServerPath, thirdServerPath, selectedPlugin]);                       

useEffect(
  () => {
    if (step === 3) {
      mandatoryFieldsCheck();
      onCircularDependenciesCheck();
    }
  },
  [step]
);

const getHeaders = () => {
  const mappedOutput = mergedHeader.map((obj, idx) => ({
    name: obj.name,
    originalName : obj.originalName,
    key: idx,
    onDetail: () =>  obj.added ? onCalcColumnValueListShow(obj.name, false) : obj.originalName !== '' ? onCalcColumnValueListShow(obj.name, true) : onCsvColumnValueListShow(obj.name),
    detailTitle: obj.name !== DOT_STAT_COLUMN_NAME
      ? t('scenes.dataManager.fileMapping.wizard.cards.csvHeader.csvComponentList.detail.title')
      : t('scenes.dataManager.fileMapping.wizard.cards.csvHeader.csvComponentList.dotStatColumnDetail.title'),
    calculated: obj.added,
    canAssociateValue: obj.added,
    tempTableName: obj.added ? tempTableName : null,
    selected: obj.selected,
    headers: true
  }));

  return mappedOutput;
}

return(
  <Call cb={onDeleteTempTable} cbParam={deleteTempTableName} disabled={checkDeleteTempTable === false}>
    <EnhancedModal
    visible={isVisible}
    onCancel={onHide}
    title={t('scenes.dataManager.fileMapping.wizard.title')}
    width={MODAL_WIDTH_XL}
    footer={
      <div>
        <Button onClick={onHide}>{t('commons.buttons.close.title')}</Button>
        {step > FILE_MAPPING_WIZARD_STEP_CUBE_SELECTION && (
          <Button onClick={() => onStepSet(step - 1)}>
            {t('scenes.dataManager.fileMapping.wizard.prevStepButton.label')}
          </Button>
        )}
        {step < FILE_MAPPING_WIZARD_STEP_NAME && (
          <Button
            onClick={() => onStepSet(step + 1)}
            disabled={
              (step === FILE_MAPPING_WIZARD_STEP_CUBE_SELECTION && cubeId === null) ||
              (step === FILE_MAPPING_WIZARD_STEP_CSV_UPLOAD && (csvServerPath === null)) ||
              (step === FILE_MAPPING_WIZARD_STEP_COMPONENT_MAPPING && components.length === 0)
            }
            type="primary"
          >
            {t('scenes.dataManager.fileMapping.wizard.nextStepButton.label')}
          </Button>
        )}
        {step === FILE_MAPPING_WIZARD_STEP_NAME && (
          <Button
            onClick={() => {
              if ((name || "").length > 0) {
                onCreateFileMapping(name, description, tid, cubeId, components, csvForm, xmlServerPath, processFileServerPath, selectedPlugin ?selectedPlugin.PluginUid: null,selectedPlugin ? selectedPlugin.Icon : null, selectedPlugin ? selectedPlugin.IconColor:null, selectedPlugin ? selectedPlugin.SequenceMappingEnabled : false, mergedHeader);
              } else {
                Modal.warning({
                  title: t('commons.alerts.invalidForm.title'),
                  content: t('commons.alerts.invalidForm.content')
                });
              }
            }}
            disabled={components.length === 0 || !mandatoryFieldsChecked || mappingHasCircularDependencies}
            type="primary"
          >
            {t('scenes.dataManager.fileMapping.wizard.saveButton.label')}
          </Button>
        )}
      </div>
    }
    withDataLanguageSelector
  >
    <div className="file-mapping__wizard">
      <FileMappingWizardCsvRowList/>
      {
        isDependencyErrorVisible && (
          <Call
            cb={() => Modal.error({
              title: t('commons.alerts.dependencyError.title'),
              content: t('commons.alerts.dependencyError.content'),
              onOk() {
                onDependencyErrorHide()
              },
              onCancel() {
                onDependencyErrorHide()
              }
            })}
          >
            <span/>
          </Call>
        )
      }
      <Call cb={fetchCube} cbParam={cubeId} disabled={cubeId === null}>
        <Call
          cb={fetchCsvHeader}
          cbParam={{
            csvServerPath,
            csvSeparator: csvForm.separator,
            csvDelimiter: !!csvForm.delimiter ? csvForm.delimiter : null,
            csvHasHeader: csvForm.hasHeader,
            csvHasDotStatFormat: csvForm.hasDotStatFormat,
            fileFormat,
          }}
          disabled={csvServerPath === null}
        >
          <Call 
            cb={fetchCalcField}
            cbParam={{
              tempTableName: tempTableName
            }}
            disabled={fetchNewField === false || tempTableName === null}
          >
            <Row style={{marginBottom: MARGIN_MD}}>
              <Col>
                <Steps current={step} size="small">
                  <Steps.Step
                    title={
                      <span
                        style={{cursor: 'pointer'}}
                        onClick={() => onStepSet(FILE_MAPPING_WIZARD_STEP_CUBE_SELECTION)}
                      >
                      {t('scenes.dataManager.fileMapping.wizard.steps.cubeSelection.title')}
                    </span>
                    }
                    icon={
                      <Button
                        shape="circle"
                        type={step === FILE_MAPPING_WIZARD_STEP_CUBE_SELECTION ? 'primary' : null}
                        onClick={() => onStepSet(FILE_MAPPING_WIZARD_STEP_CUBE_SELECTION)}
                        size="small"
                      >
                        1
                      </Button>
                    }
                    description={
                      cube !== null
                        ? (
                          <Fragment>
                            <DataLanguageConsumer>
                              {dataLanguage =>
                                <span
                                  onClick={onCubeComponentsShow}
                                  style={{cursor: 'pointer'}}
                                  title={`[${cube.Code}] ${getLocalizedStr(
                                    cube.labels,
                                    dataLanguage || appLanguage,
                                    dataLanguages
                                  )}`}
                                >
                              [{cube.Code}] {getLocalizedStr(cube.labels, dataLanguage || appLanguage, dataLanguages)}
                            </span>
                              }
                            </DataLanguageConsumer>
                            <EnhancedModal
                              visible={isCubeComponentsVisible}
                              onCancel={onCubeComponentsHide}
                              footer={<Button
                                onClick={onCubeComponentsHide}>{t('commons.buttons.close.title')}</Button>}
                              width={MODAL_WIDTH_SM}
                              title={t('scenes.dataManager.fileMapping.wizard.steps.cubeSelection.description.cubeComponents')}
                            >
                              <Card type="inner" bodyStyle={{
                                maxHeight: 460,
                                overflow: 'auto'
                              }}>
                                <CubeComponentList
                                  disabled
                                  value={cube !== null ? cube.components : null}
                                />
                              </Card>
                            </EnhancedModal>
                          </Fragment>
                        )
                        : null
                    }
                  />
                  <Steps.Step
                    title={
                      <span
                        style={cubeId !== null ? {cursor: 'pointer'} : null}
                        onClick={
                          () => cubeId !== null ? onStepSet(FILE_MAPPING_WIZARD_STEP_CSV_UPLOAD) : null
                        }
                      >
                      {t('scenes.dataManager.fileMapping.wizard.steps.fileUpload.title')}
                    </span>
                    }
                    icon={
                      <Button
                        shape="circle"
                        disabled={cubeId === null}
                        onClick={
                          () => cubeId !== null ? onStepSet(FILE_MAPPING_WIZARD_STEP_CSV_UPLOAD) : null
                        }
                        type={step === FILE_MAPPING_WIZARD_STEP_CSV_UPLOAD ? 'primary' : null}
                        size="small"
                      >
                        2
                      </Button>
                    }
                    description={
                      csvForm.file !== null
                        ? <span title={csvForm.file.name}>{csvForm.file.name}</span>
                        : null
                    }
                  />
                  <Steps.Step
                    title={
                      <span
                        style={csvServerPath !== null ? {cursor: 'pointer'} : null}
                        onClick={
                          () =>
                            csvServerPath !== null
                              ? onStepSet(FILE_MAPPING_WIZARD_STEP_COMPONENT_MAPPING)
                              : null
                        }
                      >
                      {t('scenes.dataManager.fileMapping.wizard.steps.componentsMapping.title')}
                    </span>
                    }
                    icon={
                      <Button
                        shape="circle"
                        disabled={csvServerPath === null}
                        onClick={
                          () =>
                            csvServerPath !== null
                              ? onStepSet(FILE_MAPPING_WIZARD_STEP_COMPONENT_MAPPING)
                              : null
                        }
                        type={step === FILE_MAPPING_WIZARD_STEP_COMPONENT_MAPPING ? 'primary' : null}
                        size="small"
                      >
                        3
                      </Button>
                    }
                    description={
                      components.length > 0
                        ? (
                          <Fragment>
                            <EnhancedModal
                              className="file-mapping__wizard__components-modal"
                              visible={isComponentsVisible}
                              onCancel={onComponentsHide}
                              footer={<Button
                                onClick={onComponentsHide}>{t('commons.buttons.close.title')}</Button>}
                              width={MODAL_WIDTH_SM}
                              title={t('scenes.dataManager.fileMapping.wizard.steps.componentsMapping.description.components')}
                            >
                              <FileMappingComponentList
                                mappings={components}
                                columnNameKey="ColumnName"
                                cubeComponentCodeKey="CubeComponentCode"
                              />
                            </EnhancedModal>
                            <span style={{cursor: 'pointer'}} onClick={onComponentsShow}>
                          {t('scenes.dataManager.fileMapping.wizard.steps.componentsMapping.description.mappedComponents', {
                            count: components.length
                          })}
                          </span>
                          </Fragment>
                        )
                        : null
                    }
                  />
                  <Steps.Step
                    title={
                      <span
                        style={components.length > 0 ? {cursor: 'pointer'} : null}
                        onClick={
                          () => components.length > 0 ? onStepSet(FILE_MAPPING_WIZARD_STEP_NAME) : null
                        }
                      >
                      {t('scenes.dataManager.fileMapping.wizard.steps.nameForm.title')}
                    </span>
                    }
                    icon={
                      <Button
                        shape="circle"
                        disabled={components.length === 0}
                        onClick={
                          () => components.length > 0 ? onStepSet(FILE_MAPPING_WIZARD_STEP_NAME) : null
                        }
                        type={step === FILE_MAPPING_WIZARD_STEP_NAME ? 'primary' : null}
                        size="small"
                      >
                        4
                      </Button>
                    }
                  />
                </Steps>
              </Col>
            </Row>
            <Card
              style={step !== FILE_MAPPING_WIZARD_STEP_CUBE_SELECTION ? {display: 'none'} : null}
              type="inner">
              <div className="file-mapping__wizard__cube-selector">
                <FileMappingWizardCubeSelector/>
              </div>
            </Card>
            {step === FILE_MAPPING_WIZARD_STEP_CSV_UPLOAD && (
              <Row type="flex" justify="center">
                <Col style={{width: MODAL_WIDTH_SM}}>
                  <Card type="inner">
                    <FileMappingWizardCsvUploadForm/>
                  </Card>
                </Col>
              </Row>
            )}
            <Form>
              {step === FILE_MAPPING_WIZARD_STEP_COMPONENT_MAPPING && (
                <Fragment>
                  <Row gutter={GUTTER_SM}>
                    <Col span={7}>
                      <div className="file-mapping__wizard__csv-header">
                        <Card
                          title={
                            <Row type="flex" justify="space-between">
                              <Col style={{marginTop: "auto", marginBottom: "auto"}}>
                                {t('scenes.dataManager.fileMapping.wizard.cards.csvHeader.title')}
                              </Col>
                              <Col>
                              <Button
                                title={t('scenes.dataManager.fileMapping.wizard.sortSelectList.title')}
                                icon="file-text"
                                style={{marginRight: MARGIN_SM}}
                                onClick={() => onSelectSortShow()}
                                disabled={tempTableName ? false : true}
                              >
                              </Button>
                              <Button
                                title={t('scenes.dataManager.fileMapping.wizard.downloadExport.label')}
                                onClick={() => onDownloadShow()}
                                icon="download"
                                style={{marginRight: MARGIN_SM}}
                                disabled={tempTableName ? false : true}>
                              </Button>
                              <Button
                                title={t("data.fileMapping.importCalc.label")}
                                onClick={() => onShowImportCalcRules()}
                                icon="upload"
                                disabled={tempTableName ? false : true}
                                >
                              </Button>
                              </Col>
                            </Row>
                          }{...cardStyle}
                          >
                          <Row style={{marginBottom: MARGIN_MD, height: 260}}>
                            <FileMappingWizardCsvColumnValueList/>
                            {tempTableName && (
                              <div>
                                <FileMappingWizardCalcColumnValueList/>
                                <FileMappingWizardRulesImportForm/>
                                <FileMappingWizardRulesExportForm/>
                                <FileMappingWizardAddField/>
                                <FileMappingWizardHeadersSortColumn/>
                                <FileMappingWizardCsvHeaderFormModal/>
                              </div>
                            )}
                            <FileMappingWizardComponentList
                              components={getHeaders()}
                              selected={
                                selectedColumnName !== null
                                  ? selectedColumnName
                                  : null
                              }
                              onSelect={({name, originalName, tempTableName}) => onColumnSelect(name, originalName, tempTableName)}
                              disabled={components.map(mapping =>  {
                                if(mapping.ColumnAlias !== null)
                                  return mapping.ColumnAlias;
                                else
                                  return mapping.ColumnName;
                              })}
                              showValueDefinitionButton={true}
                              onComponentCalculatedDelete={(c) => onDeleteCalcField(tempTableName, c.name)}
                              onComponentCalculatedEdit={(c) => onEditCalcField(tempTableName, c.name)}
                              onComponentCsvEdit={(c) => onEditCsvField(c)}
                              tempTableName={tempTableName ? tempTableName : null}
                            />
                          </Row>
                          <Row>
                            <Col span={SPAN_FULL}>
                              <Button
                                onClick={onAddFieldModalShow}
                                icon="plus"
                                style={{width: '100%', marginBottom: MARGIN_SM}}
                                disabled={tempTableName ? false : true}>
                                {t('data.csv.addField.label')}
                              </Button>
                              <Button
                                onClick={onCsvRowListShow}
                                icon="table"
                                disabled={csvHeader === null}
                                style={{width: '100%', marginBottom: MARGIN_SM}}>
                                {t('data.csv.tableShowButton.label')}
                              </Button>
                              {tempTableName ?
                                <Button
                                  onClick={onPreview}
                                  icon="table"
                                  style={{width: '100%'}}>
                                  {t('data.csv.calcTableShowButton.label')}
                                </Button>
                              : 
                              <Fragment>
                              <Button
                                  onClick={onModalTempTableShow}
                                  icon="check"
                                  disabled={tempTableName ? true : false}
                                  style={{width: '100%'}}>
                                  {t('scenes.dataManager.fileMapping.wizard.enableCalcField.label')}
                                </Button>
                              <EnhancedModal
                                visible={showModal}
                                title={t("scenes.dataManager.fileMapping.wizard.enableTransformationReport.label")}
                               onCancel={onModalTempTableHide}
                                footer={
                                  <Fragment>
                                    <Button onClick={onModalTempTableHide}>
                                      {t('commons.buttons.cancel.title')}
                                    </Button>
                                    <Button 
                                    type='primary' 
                                    onClick={() => onEnableCalcFields(csvServerPath, csvForm.separator, csvForm.delimiter, fileFormat)}
                                    >
                                      {t('commons.buttons.confirm.title')}
                                    </Button>
                                  </Fragment>
                                }
                                width={MODAL_WIDTH_SM}
                              >
                                <Row >
                                {t("scenes.dataManager.fileMapping.wizard.enableTransformationReport.description")}
                                </Row>
                              </EnhancedModal>
                            </Fragment>
                              }
                            </Col>
                          </Row>
                        </Card>
                      </div>
                    </Col>
                    <Col span={10}>
                      <div className="file-mapping__wizard__component-mapper">
                        <Card {...cardStyle}>
                          <FileMappingWizardComponentMapper/>
                        </Card>
                      </div>
                    </Col>
                    <Col span={7}>
                      <div className="file-mapping__wizard__cube-components">
                        <Card
                          title={t('scenes.dataManager.fileMapping.wizard.cards.cubeComponents.title')}{...cardStyle}>
                          <FileMappingWizardCubeComponentList
                            componentValueDefinitionFormVisible={componentValueDefinitionFormVisible}
                            onComponentValueDefinitionFormShow={onComponentValueDefinitionFormShow}
                            onComponentValueDefinitionFormHide={onComponentValueDefinitionFormHide}
                            onComponentValueDefinitionSave={onComponentValueDefinitionSave}
                            onComponentValueDefinitionTypeSet={onComponentValueDefinitionTypeSet}
                            componentValueDefinition={componentValueDefinition}
                            onComponentValueDefinitionValueSet={onComponentValueDefinitionValueSet}
                            componentCodelistCodesItemsPage={componentCodelistCodesItemsPage}
                            componentCodelistCodesItemsCount={componentCodelistCodesItemsCount}
                            fetchCodelistCodesItemsPage={fetchCodelistCodesItemsPage}
                          />
                        </Card>
                      </div>
                    </Col>
                  </Row>
                  {!(cube === null || cube.components.tidAttributes.length === 0) && (
                    <Card type="inner" style={{marginTop: MARGIN_MD}}>
                      <Row type="flex" justify="center">
                        <Col span={SPAN_ONE_THIRD}>
                          <Form.Item
                            label={t('data.fileMapping.tid.label')}
                            validateStatus={tid && isIDValidWithHelp(t, tid).help ? "warning" : null}
                            help={tid && isIDValidWithHelp(t, tid).help}
                            {...formItemLayout}
                          >
                            {form.getFieldDecorator('tid', {
                              getValueFromEvent: e => e.target.value.toUpperCase()
                            })(
                              <Input
                                title={form.getFieldValue('tid')}
                                style={{textTransform: "uppercase"}}
                              />)}
                          </Form.Item>
                        </Col>
                      </Row>
                    </Card>
                  )}
                </Fragment>
              )}
              {step === FILE_MAPPING_WIZARD_STEP_NAME && (
                <Row type="flex" justify="center">
                  <Col span={SPAN_FULL}>

                  {!components
                      .map((mapping) => mapping.CubeComponentCode)
                      .includes("OBS_VALUE") &&
                      mandatoryFieldsChecked &&
                      !mappingHasCircularDependencies && (
                        <Alert
                          message={t("scenes.dataManager.fileMapping.wizard.cards.name.warnings.obsValue")}
                          type="warning"
                          showIcon
                        />
                      )}


                  {!mandatoryFieldsChecked && (
                      <Alert
                        message={t("scenes.dataManager.fileMapping.wizard.cards.name.errors.mandatoryFields")}
                        type="error"
                        showIcon
                      />
                    )}

                    {mappingHasCircularDependencies && (
                      <Alert
                        message={t("scenes.dataManager.fileMapping.wizard.cards.name.errors.circularDependencies")}
                        type="error"
                        showIcon
                      />
                    )}

                    <Card type="inner">
                      <Form.Item
                        className="form-item-required"
                        label={t('data.fileMapping.name.label')}
                        {...stepNameFormItemLayout}
                      >
                        {form.getFieldDecorator('name', {
                          getValueFromEvent: e => (e || "").toUpperCase()
                        })(
                          <PerfInput
                            Component={Input}
                            title={form.getFieldValue('name')}
                            style={{textTransform: "uppercase"}}
                          />
                        )}
                      </Form.Item>
                      <Form.Item
                        label={t('data.fileMapping.description.label')} {...stepNameFormItemLayout}>
                        {form.getFieldDecorator('description')(
                          <ZoomableTextArea title={form.getFieldValue('description')}/>
                        )}
                      </Form.Item>
                    </Card>
                  </Col>
                </Row>
              )}
            </Form>
          </Call>
        </Call>
      </Call>
    </div>
    </EnhancedModal>
  </Call>);}

export default compose(
  translate(),
  connect(mapStateToProps, mapDispatchToProps),
  Form.create({
    mapPropsToFields,
    onFieldsChange
  })
)(FileMappingWizard);
